export const schoolProgramHeaders = [
  {
    key: "delivery_type",
    label: "Delivery Type",
  },
  {
    key: "program_type",
    label: "Program Type",
  },
  {
    key: "school_name",
    label: "School",
  },
  {
    key: "day",
    label: "Day",
  },
  {
    key: "program_time",
    label: "Time",
  },
  {
    key: "program_duration",
    label: "Duration",
  },
  {
    key: "sessions",
    label: "Sessions",
  },
  {
    key: "course_abbr",
    label: "Stream (Abbr)",
  },
  {
    key: "student_id",
    label: "Student ID",
  },
  {
    key: "student_name",
    label: "Student Name",
  },
  {
    key: "parent_name",
    label: "Parent Name",
  },
  {
    key: "phone",
    label: "Phone Number",
  },
  {
    key: "email",
    label: "Email Address",
  },
  {
    key: "alternate_emails",
    label: "Alternate Emails",
  },
  {
    key: "dob",
    label: "DOB",
  },
  {
    key: "allergies",
    label: "Allergies",
  },
  {
    key: "special_need",
    label: "Special Needs",
  },
];
